module.exports = __webpack_public_path__ + "img/Chriqui_Josh.0e9a67eb.png";